import { render } from "./nav-menu.vue?vue&type=template&id=c772e7bc&ts=true"
import script from "./nav-menu.ts?vue&type=script&lang=ts&external"
export * from "./nav-menu.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__